<select (change)="onChanged($event)"
    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-primary-500 w-full ease-linear transition-all duration-150">
    <option [selected]="selectedGender == 'male'" value="male">Male</option>
    <option [selected]="selectedGender == 'female'" value="female">Female</option>
    <option [selected]="selectedGender == 'unspecified'" value="unspecified">Unspecified</option>
</select>